<div class="perks" id="perks">
  <div class="container">
    <h2 class="perks__section-title">Perks and benefits</h2>
    <div class="perks__section-benefits row">
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-md-4"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/growth.svg"
          width="82"
          height="77"
          alt="growth"
        />
        <p class="perks__section-item-text display display-4b">
          Growth-oriented feedback culture
        </p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-md-4"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="100"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/rotational.svg"
          width="82"
          height="77"
          alt="rotational opportunities"
        />
        <p class="perks__section-item-text display display-4b">
          Rotational opportunities for diverse experiences
        </p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-md-4"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="200"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/supportive.svg"
          width="82"
          height="77"
          alt="supportive environment"
        />
        <p class="perks__section-item-text display display-4b">
          Supportive and friendly work environment
        </p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-md-4"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="300"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/active.svg"
          width="82"
          height="77"
          alt="professional community"
        />
        <p class="perks__section-item-text display display-4b">
          Active professional community
        </p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-md-4"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="400"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/emphasis.svg"
          width="82"
          height="77"
          alt="work-life balance"
        />
        <p class="perks__section-item-text display display-4b">
          Emphasis on work-life balance
        </p>
      </div>
      <div
        class="perks__section-item col-6 col-md-4 d-xl-none"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="500"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/medical.svg"
          width="82"
          height="77"
          alt="medical care"
        />
        <p class="perks__section-item-text display display-4b">Medical care</p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item d-none d-xl-flex col-xl-2"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="600"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/medical.svg"
          width="82"
          height="77"
          alt="medical care"
        />
        <p class="perks__section-item-text display display-4b">Medical care</p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-md-4"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="700"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/multisport.svg"
          width="82"
          height="77"
          alt="multisport"
        />
        <p class="perks__section-item-text display display-4b">Multisport</p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-md-4"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="800"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/training.svg"
          width="82"
          height="77"
          alt="budget"
        />
        <p class="perks__section-item-text display display-4b">
          Training budget
        </p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-6 col-xl-2 d-md-none d-xl-flex"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="1000"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/german.svg"
          width="82"
          height="77"
          alt="budget"
        />
        <p class="perks__section-item-text display display-4b">
          German lessons
        </p>
      </div>
      <div
        [ngClass]="threeColumnsGrid() ? 'col-xl-4' : 'col-xl-2'"
        class="perks__section-item col-md-4 d-none d-md-flex d-xl-none"
        data-aos="fade-down"
        data-aos-easing="linear"
        data-aos-duration="300"
        data-aos-delay="1100"
      >
        <img
          class="perks__section-item-icon"
          ngSrc="../../../../assets/perks/languages.svg"
          width="82"
          height="77"
          alt="German class"
        />
        <p class="perks__section-item-text display display-4b">
          German lessons
        </p>
      </div>
    </div>
  </div>
</div>
